import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppPhase, SupervisorAction, SupervisorSubPhase, WorkerAccessLevel } from '../../../models/communication/app-enums.model';
import { Game, SupervisorState } from '../../../models/communication/app-state.model';
import { SupervisorPanelComponent } from '../supervisor-panel/supervisor-panel.component';

/**
 * Showing a correct {@link SupervisorPanelComponent}
 * based on the provided state (`supervisorState.subPhase` and `supervisorState.selectedAction`).
 *
 * The panels are used to inform the supervisor about the different states of the app,
 * mostly to confirm the previously selected action.
 */
@Component({
    selector: 'app-supervisor-confirm-panels',
    standalone: true,
    imports: [CommonModule, SupervisorPanelComponent],
    templateUrl: './supervisor-confirm-panels.component.html'
})
export class SupervisorConfirmPanelsComponent {
    @Input()
    supervisorState?: SupervisorState;

    @Input()
    currentGame?: Game;

    @Output()
    readonly cancelActionClicked = new EventEmitter();

    protected readonly AppPhase = AppPhase;
    protected readonly WorkerAccessLevel = WorkerAccessLevel;
    protected readonly SupervisorSubPhase = SupervisorSubPhase;
    protected readonly SupervisorAction = SupervisorAction;
}
